const normalizeFornoObservationKey = (value: string): string =>
  value.trim().toLowerCase().normalize("NFD").replace(/\p{M}/gu, "");

const FORNO_OBSERVATION_PLACEHOLDERS = new Set([
  "sem observacao",
  "sem observacoes",
  "nenhuma observacao",
]);

const isSemBordaLabel = (value: string | null | undefined): boolean => {
  const normalized = (value ?? "").trim().toLowerCase();
  return !normalized || normalized === "sem borda";
};

/** Prioriza borda da API quando a descrição gravada ficou genérica ("Sem borda"). */
export function resolveFornoBordaLabel(
  descricao: string,
  borda?: { nome: string } | null
): string {
  const trimmed = descricao.trim();
  const linhas = trimmed.includes("\n")
    ? trimmed
        .split("\n")
        .map((l) => l.trim())
        .filter(Boolean)
    : [];
  const bordaFromDescricao = linhas.length >= 2 ? linhas[1] : null;
  const bordaFromApi = borda?.nome?.trim() || null;

  if (isSemBordaLabel(bordaFromDescricao) && !isSemBordaLabel(bordaFromApi)) {
    return bordaFromApi!;
  }

  return bordaFromDescricao || bordaFromApi || "Sem borda";
}

/**
 * Junta todas as fontes (como o Montador), em vez de pegar só a primeira.
 * No iFood o observation do pedido costuma ser metadado e a nota real vem
 * em item.observation / items[].
 */
export function resolveFornoPedidoObservation(
  ...sources: (string | null | undefined)[]
): string | null {
  const seen = new Set<string>();
  const parts: string[] = [];
  for (const raw of sources) {
    for (const part of String(raw ?? "").split(" | ")) {
      const trimmed = part.trim();
      if (!trimmed) continue;
      const key = normalizeFornoObservationKey(trimmed);
      if (FORNO_OBSERVATION_PLACEHOLDERS.has(key) || seen.has(key)) continue;
      seen.add(key);
      parts.push(trimmed);
    }
  }
  return parts.length > 0 ? parts.join(" | ") : null;
}

export function resolveFornoItemObservation(item: {
  observation?: string | null;
  pedidoFoodfly?: { observacao?: string | null } | null;
  pedidoIntegracao?: {
    observation?: string | null;
    internalObservation?: string | null;
  } | null;
}): string | null {
  return resolveFornoPedidoObservation(
    item.observation,
    item.pedidoFoodfly?.observacao,
    item.pedidoIntegracao?.observation,
    item.pedidoIntegracao?.internalObservation
  );
}
